import {useCookie} from '#imports';
import {ratsinfoUser, setRatsinfoUser} from '../composables/ratsinfoauth.mjs';

export default {
	computed: {
		user() {
			return ratsinfoUser;
		},
	},

	created() {
		const Cookie = useCookie('ratsinfoauth');
		if (process.client && this.user.value && Cookie.value === undefined) {
			// this.$store.commit('nuxtKommunen/ratsinfoauth/setUser', null);
			setRatsinfoUser(null);
			this.$router.push({
				path: '/rathaus/ratsinfosystem',
			});
		}
	},
};
